import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { Grid, Row, ChipStatus, BaseText } from '@warrenbrasil/nebraska-web';

import { IProductGetLastState } from '@/modules/catalog/services/products-acquisition';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface Props {
  product: IProductGetLastState;
  addProduct?: boolean;
  isSelected: boolean;
}

interface EmitEvents {
  (event: 'handle-instrument-click', { id }: { id: string }): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCard',
  props: {
    product: null,
    addProduct: { type: Boolean },
    isSelected: { type: Boolean }
  },
  emits: ["handle-instrument-click"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'handle-instrument-click', { id }: { id: string }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  product: IProductGetLastState;
  addProduct?: boolean;
  isSelected: boolean;
};




const chipStatus = computed(() => {
  const mapLevelRisk: { [key: string]: string } = {
    LOW: 'positive',
    MEDIUM: 'alert',
    HIGH: 'negative'
  };

  return mapLevelRisk[props.product.risk.value];
});

function onSelect() {
  emit('handle-instrument-click', {
    id: props.product.productId ?? props.product.id
  });
}

return { __sfc: true,props, emit, chipStatus, onSelect, Grid, Row, ChipStatus, BaseText, NebraskaColors }
}

})